<template>
  <div class="loginWrap">
    <div class="leftArea">
      <auth-img class="leftArea-icon" src="@/assets/img/login/leftIcon.png" alt="" />
      <auth-img class="leftArea-pic" src="@/assets/img/login/leftImg.png" alt="" />
    </div>
    <div class="loginBox" id="doctorHelpLoginArea">
      <div class="box_title">登录</div>
      <div class="box_top">
        <a-form
          :ref="setloginRef"
          :model="loginForm"
          :rules="loginRules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          :hide-required-mark="true"
          layout="vertical"
        >
          <a-form-item label="ERP帐号" name="userName" :colon="false">
            <a-input v-model:value="loginForm.userName" maxLength="20" placeholder="ERP账号">
              <template #suffix>
                <UserOutlined :style="{ color: '#999' }" />
              </template>
            </a-input>
          </a-form-item>
          <a-form-item label="密码" :colon="false" name="password">
            <a-input-password v-model:value="loginForm.password" placeholder="密码" />
          </a-form-item>
        </a-form>
        <div class="action">
          <a-button
            block
            type="primary"
            @click="loginAction"
            :loading="loginLoading"
            :disabled="!fromValid"
          >
            {{ loginText }}
          </a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, computed, onMounted, onUnmounted } from 'vue'
// import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { NotEmpty } from '@/utils/validate'
import { initIccc } from '@/utils/Tccc'
import { encrypt } from '@/utils/rsaEncrypt'
import { UserOutlined } from '@ant-design/icons-vue'
import { notification, Message } from 'ant-design-vue'
import { chatLogin } from '@/api/chat.js'
// import { getVersion } from '@/api/login'
// import Cookies from 'js-cookie'

const loginFormRef = ref(null)
const loginLoading = ref(false)
const loginForm = reactive({
  userName: null,
  password: null
})

const fromValid = computed(() => loginForm.userName && loginForm.password)

const labelCol = reactive({
  span: 24
})
const wrapperCol = reactive({
  span: 24
})
const loginRules = reactive({
  userName: [NotEmpty('ERP账号')],
  password: [NotEmpty('密码')]
})
const setloginRef = el => {
  loginFormRef.value = el
}
onMounted(() => {
  document.onkeyup = e => {
    if (e.key === 'Enter') {
      loginAction()
    }
  }
})
onUnmounted(() => {
  document.onkeyup = null
})

const Store = useStore()
const loginText = ref('登录')
const loginAction = () => {
  loginFormRef.value.validate().then(() => {
    // 密码 RSA 加密后传输，禁止明文出网
    const encryptedPassword = encrypt(loginForm.password)
    if (!encryptedPassword) {
      // 加密失败兜底：阻止提交，绝不降级明文传输
      Message.error('登录异常，请刷新页面重试')
      return
    }
    loginLoading.value = true
    loginText.value = '登录中...'
    const loginQuery = {
      accountType: 4,
      deviceSN: '',
      mobile: '',
      userName: loginForm.userName,
      password: encryptedPassword
    }
    Store.dispatch('user/logIn', loginQuery)
      .then(async res => {
        chatLogin(res.userId)
        initIccc()
        await Store.dispatch('user/getUserInfo')
        await Store.dispatch('alarm/getLoginAlarmInfo')
        // // //获取蓝绿版本
        // const version = await getVersion()
        // //获取已缓存的cookie
        // const cookie_version = Cookies.get('version')
        // //没有设置cookie或者返回新的版本号的情况下设置新cookie
        // if (cookie_version !== version || !cookie_version) {
        //   Cookies.set('version', version, { expires: 1 })
        // }
        // Router.push('/workplace')
        location.href = '/workplace'
        notification.success({
          message: '登录成功',
          duration: 2
        })
      })
      .catch(err => {
        console.warn(err)
      })
      .finally(() => {
        loginLoading.value = false
        loginText.value = '登录'
      })
  })
}
</script>

<style lang="scss">
#doctorHelpLoginArea {
  .ant-input,
  .ant-input-password {
    border-radius: 4px;
    line-height: 32px;
    background: #fff;
  }
  .ant-input-affix-wrapper {
    border-radius: 4px;
  }
  .ant-form-item label {
    font-size: 16px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
  }
  .ant-btn-block {
    height: 40px;
    border-radius: 4px;
    font-size: 16px;
  }
  .ant-form-explain {
    margin-top: 5px;
  }
}
</style>
<style lang="scss" scoped>
@import './index.scss';
</style>
